module.exports = __webpack_public_path__ + "img/instagram.9907672.svg";